export function toCurrency(value?: number | string): string {
  if (value === undefined) {
    return ''
  }

  return Number(value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}

export function toString(value: any): string {
  return String(value)
}

export function toGeoName(
  city?: string | null,
  state?: string,
  regionType?: string
): string {
  if (city === 'National' || regionType === 'national') {
    return 'National'
  }
  if (
    (city !== 'Undefined' && city !== null && city) ||
    regionType === 'place'
  ) {
    return `${city}${state ? ', ' + state.toUpperCase() : ''}`
  } else if (state || regionType === 'state') {
    return stateAbbrNameMap[String(state)] || String(state).toUpperCase()
  }
  return ''
}

export function convertToKebabCase(value: string): string {
  return String(value)
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
}

export function convertFromKebabCase(value?: string) {
  if (!value) return value

  return String(value)
    .replace(/-/g, ' ')
    .replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase()
    })
}

export const stateAbbrNameMap: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming'
}
